function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

export var _getBaseStyle = function _getBaseStyle() {
  return {
    overflowX: 'auto',
    '&::-webkit-scrollbar': {
      width: 0,
      height: 0
    }
  };
};
export var _getTabWrapperStyle = function _getTabWrapperStyle(props) {
  var centered = props.centered;
  return {
    textAlign: centered ? 'center' : 'left',
    justifyContent: centered ? 'center' : 'left'
  };
};

var getAppearance = function getAppearance(props) {
  var appearanceMapping = {
    card: {
      backgroundColor: 'black'
    },
    "default": {
      backgroundColor: 'blue.500'
    }
  };
  return appearanceMapping[props.appearance];
};

export var _getIndicatorStyle = function _getIndicatorStyle(props) {
  return _objectSpread({
    transition: 'transform 400ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, width  400ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    zIndex: 2
  }, getAppearance(props));
};